import { rqx } from '../../../core/request/API'
import { env } from '../../../core/Env'

const endpoint = method =>
    `<<tool>>/${env() === 'dev' ? 'local' : env()}/general-maintenance/cloud/policy/${method}`

export const readGuidelines = ({
    isRegular, companyId, departmentIds = [], departmentOwnedId, userId,
    lastId = 0, limit = 20, filter = ''
}) => {
    const params = {
        ref: isRegular ? 'ruser' : 'admin',
        company_id: companyId,
        dept_id: JSON.stringify(departmentIds),
        lastId,
        limit,
        filter
    }
    if (isRegular) {
        params.deptOwnedId = departmentOwnedId
        params.user_id = userId
    }
    return rqx.get(endpoint('read'), params)
}

export const viewGuidelineVersion = id => rqx.get(endpoint('view'), { id })

export const updateGuidelineVersion = ({ id, userId, remove = false }) =>
    rqx.post(endpoint('update'), {
        id,
        user_id: userId,
        fltr: remove ? 'remove' : 'issue'
    })

export const agreeGuidelineVersions = ({ userId, ids, companyId, departmentId }) => {
    const payload = {
        user_id: userId,
        id: JSON.stringify(ids)
    }
    if (ids === 'all') {
        payload.company_id = companyId
        payload.dept_id = departmentId
    }
    return rqx.post(endpoint('agree'), payload)
}

export const getGuidelineAgreeCount = cpid =>
    rqx.get(endpoint('agreecount'), { cpid })

export const getGuidelineAgreeList = cpid =>
    rqx.get(endpoint('agreelist'), { cpid })

export const validateGuidelineAcknowledgement = ({ companyId, departmentId, userId }) =>
    rqx.get(endpoint('polvalidate'), {
        company_id: companyId,
        dept_id: departmentId,
        user_id: userId
    })
